import { Phone, Mail, MapPin } from "lucide-react";
import { trackPhoneCall } from "@/lib/googleAds";

export default function Footer() {
  return (
    <footer className="bg-[#0a1628] py-12">
      <div className="container px-4">
        {/* Top row: brand + 3 link columns */}
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img
              src="https://files.manuscdn.com/user_upload_by_module/session_file/310519663313033271/KuIXmYeHtVqHONwe.png"
              alt="Danis Painting Co. — Award-Winning Painting Contractors"
              className="h-12 w-auto mb-4"
              width="180"
              height="48"
              loading="lazy"
            />
            <p className="text-white/60 text-sm mb-4">
              Over 30 years of exceptional quality and craftsmanship. Danis Painting brings honest New England quality to every jobsite in Santa Barbara, Ventura, and Los Angeles.
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex gap-3">
                <a
                  href="http://facebook.com/profile.php?id=61568678263513"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Danis Painting Co. on Facebook"
                  className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                >
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </a>
                <a
                  href="https://www.instagram.com/danispainting805"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Danis Painting Co. on Instagram"
                  className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                >
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                </a>
              </div>
              <a href="https://www.bbb.org/us/ca/santa-barbara/profile/painting-contractors/danis-painting-1236-92008136/#sealclick" target="_blank" rel="nofollow">
                <img src="https://seal-santabarbara.bbb.org/seals/blue-seal-200-42-whitetxt-bbb-92008136.png" alt="Danis Painting BBB Accredited Business — Santa Barbara" className="h-10 w-auto" width="200" height="42" loading="lazy" />
              </a>
              <div className="px-3 py-2 bg-white/5 border border-white/10 rounded-lg flex items-center gap-2 w-fit">
                <svg className="w-5 h-5 text-green-400 shrink-0" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                <div className="flex flex-col">
                  <span className="text-xs text-white/80 font-medium">Licensed & Insured</span>
                  <span className="text-xs text-white/50">LIC #662554</span>
                </div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Services</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/service/interior-exterior-painting" className="text-white/60 hover:text-white transition-colors">Interior & Exterior Painting</a></li>
              <li><a href="/service/commercial-painting" className="text-white/60 hover:text-white transition-colors">Commercial Painting</a></li>
              <li><a href="/service/cabinet-painting" className="text-white/60 hover:text-white transition-colors">Cabinet Painting</a></li>
              <li><a href="/service/roof-coating-repair" className="text-white/60 hover:text-white transition-colors">Roof Coating & Repair</a></li>
              <li><a href="/service/waterproofing" className="text-white/60 hover:text-white transition-colors">Waterproofing</a></li>
              <li><a href="/service/pressure-washing" className="text-white/60 hover:text-white transition-colors">Pressure Washing</a></li>
              <li><a href="/service/drywall-repair" className="text-white/60 hover:text-white transition-colors">Drywall Repair</a></li>
              <li><a href="/service/deck-staircase-repair" className="text-white/60 hover:text-white transition-colors">Deck & Staircase Repair</a></li>
              <li><a href="/service/trim-molding" className="text-white/60 hover:text-white transition-colors">Trim & Molding</a></li>
              <li><a href="/service/exterior-painting" className="text-white/60 hover:text-white transition-colors">Exterior Painting</a></li>
              <li><a href="/service/venetian-plaster" className="text-white/60 hover:text-white transition-colors">Venetian Plaster</a></li>
              <li><a href="/service/lime-wash" className="text-white/60 hover:text-white transition-colors">Lime Wash</a></li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Service Areas</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/city/santa-barbara" className="text-white/60 hover:text-white transition-colors">Santa Barbara</a></li>
              <li><a href="/city/ventura" className="text-white/60 hover:text-white transition-colors">Ventura</a></li>
              <li><a href="/city/montecito" className="text-white/60 hover:text-white transition-colors">Montecito</a></li>
              <li><a href="/city/goleta" className="text-white/60 hover:text-white transition-colors">Goleta</a></li>
              <li><a href="/city/carpinteria" className="text-white/60 hover:text-white transition-colors">Carpinteria</a></li>
              <li><a href="/city/ojai" className="text-white/60 hover:text-white transition-colors">Ojai</a></li>
              <li><a href="/city/camarillo" className="text-white/60 hover:text-white transition-colors">Camarillo</a></li>
              <li><a href="/city/solvang" className="text-white/60 hover:text-white transition-colors">Solvang</a></li>
              <li><a href="/city/buellton" className="text-white/60 hover:text-white transition-colors">Buellton</a></li>
              <li><a href="/city/santa-ynez" className="text-white/60 hover:text-white transition-colors">Santa Ynez</a></li>
              <li><a href="/city/isla-vista" className="text-white/60 hover:text-white transition-colors">Isla Vista</a></li>
              <li><a href="/city/summerland" className="text-white/60 hover:text-white transition-colors">Summerland</a></li>
              <li><a href="/city/oxnard" className="text-white/60 hover:text-white transition-colors">Oxnard</a></li>
              <li><a href="/city/los-angeles" className="text-white/60 hover:text-white transition-colors">Los Angeles</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:805-403-8727" onClick={trackPhoneCall} className="flex items-center gap-2 text-white/60 hover:text-white transition-colors">
                  <Phone className="w-4 h-4" />
                  805-403-8727
                </a>
              </li>
              <li>
                <a href="mailto:danispainting@gmail.com" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors">
                  <Mail className="w-4 h-4" />
                  danispainting@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps/search/133+E+De+La+Guerra+St+Santa+Barbara+CA+93101"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/60 hover:text-white transition-colors"
                >
                  <MapPin className="w-4 h-4" />
                  <span className="text-xs leading-relaxed">133 E De La Guerra St<br />Santa Barbara, CA 93101</span>
                </a>
              </li>
            </ul>
            <div className="mt-4 space-y-2 text-sm">
              <a href="/blog" className="block text-white/60 hover:text-white transition-colors">Painting Blog</a>
              <a href="/faq" className="block text-white/60 hover:text-white transition-colors">FAQ</a>
              <a href="/service-areas" className="block text-white/60 hover:text-white transition-colors">All Service Areas</a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Danis Painting Co. All rights reserved.
          </p>
          <p className="text-white/40 text-sm">
            Best of 2025 Santa Barbara Award Winner
          </p>
        </div>
      </div>
    </footer>
  );
}
